var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBullishArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5356 6.46479L6.46455 13.5359M13.5356 6.46479H8.23231M13.5356 6.46479V11.7681M4.10752 15.8929C0.853156 12.6385 0.853156 7.36214 4.10752 4.10777C7.36189 0.8534 12.6383 0.8534 15.8926 4.10777C19.147 7.36214 19.147 12.6385 15.8926 15.8929C12.6383 19.1473 7.36189 19.1473 4.10752 15.8929Z",
    stroke: "#A4ABB8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullishArrow);
export default __webpack_public_path__ + "static/media/bullish-arrow.596e81894a80cdafbe2082348d0199b5.svg";
export { ForwardRef as ReactComponent };